import { Box, Flex, Text } from "@mantine/core"
import { CheckIcon } from "@phosphor-icons/react";
import classes from "./status-bar.module.css"

type StatusStep = {
  code: string
  name: string
  color?: string
}

type Props = {
  statuses: StatusStep[]
  currentStatus: string
}

export function StatusBar({ statuses, currentStatus }: Props) {
  const currentIndex = statuses.findIndex((s) => s.code === currentStatus)

  return (
    <Box className={classes.root}>
      <Flex align="center" className={classes.track}>
        {statuses.map((status, i) => {
          const isPast = i < currentIndex
          const isCurrent = i === currentIndex
          const isActive = isPast || isCurrent
          // Same scheme as OrderStepper: done green, current dark (the catalogue colour is not used here).
          const accent = isPast ? "var(--mantine-color-green-6)" : "var(--mantine-color-dark-8)"
          const state = isPast ? "past" : isCurrent ? "current" : "future"

          return (
            <Flex key={status.code} align="center" style={{ flex: i < statuses.length - 1 ? 1 : undefined }}>
              <Flex direction="column" align="center" gap={6} className={classes.step}>
                <Box
                  className={classes.dot}
                  data-state={state}
                  style={
                    isPast
                      ? { background: accent, borderColor: accent }
                      : isCurrent
                      ? { borderColor: accent, boxShadow: `0 0 0 5px color-mix(in srgb, ${accent} 18%, transparent)` }
                      : undefined
                  }
                >
                  {isPast && <CheckIcon size={14} color="var(--mantine-color-white)" />}
                  {isCurrent && (
                    <Box
                      className={classes.pulse}
                      style={{ background: accent }}
                    />
                  )}
                </Box>
                <Text
                  fz={14}
                  fw={isCurrent ? 700 : isActive ? 600 : 500}
                  c={isActive ? "var(--mantine-color-dark-7)" : "var(--mantine-color-gray-6)"}
                  ta="center"
                  style={{ whiteSpace: "nowrap", letterSpacing: isCurrent ? "0.01em" : 0 }}
                >
                  {status.name}
                </Text>
              </Flex>
              {i < statuses.length - 1 && (
                <Box
                  className={classes.line}
                  data-active={isPast ? "true" : "false"}
                />
              )}
            </Flex>
          )
        })}
      </Flex>
    </Box>
  )
}
